import { Wizard } from '@lounge-fe/ui-kit'
import { useTranslation } from 'react-i18next'
import { StepLayout } from '../StepLayout'
import { StepActions } from '../StepActions'
import { StepChoiceChips } from '../StepChoiceChips'

export const CupFit = () => {
  const { t } = useTranslation()
  return (
    <Wizard.Step>
      {({ watch }) => {
        const cupSize = watch('cupSize')
        return (
          <StepLayout
            title={t('fitting_room.cup_fit.title', { cup_size: cupSize })}
            subtitle={t('fitting_room.cup_fit.subtitle')}
          >
            <StepChoiceChips
              className="!grid-cols-1"
              name="cupFit"
              options={[
                {
                  value: 'tight',
                  label: t('fitting_room.cup_fit.choice_tight'),
                },
                {
                  value: 'comfortable',
                  label: t('fitting_room.cup_fit.choice_comfortable'),
                },
                {
                  value: 'loose',
                  label: t('fitting_room.cup_fit.choice_loose'),
                },
              ]}
            />
            <StepActions next={false} />
          </StepLayout>
        )
      }}
    </Wizard.Step>
  )
}
